import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/Users/nursultanberkimbay/Projects/charm-docs/src/components/layout.js"
import Example from '../../components/Example'

export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={props}
             components={components}>


<MDXTag name="h1" components={components} props={{"id":"typography"}}>{`Typography`}</MDXTag>
<MDXTag name="hr" components={components}></MDXTag>
<MDXTag name="p" components={components}>{`Charm UI includes basic global styles and text utility classes. Read more about utility classes on `}<MDXTag name="a" components={components} parentName="p" props={{"href":"/charm-docs/components/utilities","title":"Utilities"}}>{`Utilities page`}</MDXTag></MDXTag>
<MDXTag name="h3" components={components} props={{"id":"headings"}}>{`Headings`}</MDXTag>
<MDXTag name="p" components={components}>{`Heading `}<MDXTag name="inlineCode" components={components} parentName="p">{`h1`}</MDXTag>{` through `}<MDXTag name="inlineCode" components={components} parentName="p">{`h3`}</MDXTag>{` classes are also available, for when you want to match the font styling of a heading but cannot use the associated HTML element.`}</MDXTag>
<MDXTag name="table" components={components}>
<MDXTag name="thead" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="thead">
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Tag`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Class`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Markdown`}</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="tbody" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<h1></h1>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="h1"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`#`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<h2></h2>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="h2"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`##`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<h3></h3>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="h3"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`###`}</MDXTag></MDXTag>
</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"lead"}}>{`Lead`}</MDXTag>
<MDXTag name="p" components={components}>{`Use `}<MDXTag name="inlineCode" components={components} parentName="p">{`.lead`}</MDXTag>{` class to make Lead component.`}</MDXTag>
<MDXTag name="table" components={components}>
<MDXTag name="thead" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="thead">
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Tag`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Class`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Markdown`}</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="tbody" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}>{`—`}</MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="lead"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}>{`—`}</MDXTag>
</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"inline-text"}}>{`Inline text`}</MDXTag>
<MDXTag name="p" components={components}>{`Usage of common inline text elements.`}</MDXTag>
<MDXTag name="table" components={components}>
<MDXTag name="thead" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="thead">
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Tag`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Class`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Markdown`}</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="tbody" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<a></a>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="link"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`[Link name](/link/to "Link")`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<code></code>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="code"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`\`code\``}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<strong></strong>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="strong"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`**strong\**`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<em></em>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="em"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`*emphasis*`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<small></small>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="small"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}>{`—`}</MDXTag>
</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"blockquotes"}}>{`Blockquotes`}</MDXTag>
<MDXTag name="p" components={components}>{`Use `}<MDXTag name="inlineCode" components={components} parentName="p">{`.blockquote`}</MDXTag>{` class to make Blockquote component.`}</MDXTag>
<MDXTag name="table" components={components}>
<MDXTag name="thead" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="thead">
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Tag`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Class`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Markdown`}</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="tbody" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<blockquote></blockquote>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="blockquote"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`> Blockquote text`}</MDXTag></MDXTag>
</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"list"}}>{`List`}</MDXTag>
<MDXTag name="p" components={components}>{`Use `}<MDXTag name="inlineCode" components={components} parentName="p">{`.list`}</MDXTag>{` class to make List component.`}</MDXTag>
<MDXTag name="table" components={components}>
<MDXTag name="thead" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="thead">
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Tag`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Class`}</MDXTag>
<MDXTag name="th" components={components} parentName="tr" props={{"align":null}}>{`Markdown`}</MDXTag>
</MDXTag>
</MDXTag>
<MDXTag name="tbody" components={components} parentName="table">
<MDXTag name="tr" components={components} parentName="tbody">
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`<ul><li></li></ul>`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`class="list"`}</MDXTag></MDXTag>
<MDXTag name="td" components={components} parentName="tr" props={{"align":null}}><MDXTag name="inlineCode" components={components} parentName="td">{`- Link item`}</MDXTag></MDXTag>
</MDXTag>
</MDXTag>
</MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  